<template>
  <component :is="isLexisNexisChecklist ? 'LexisNexisChecklistTableItem' : 'SavedChecklistTableItem'"
              v-for="checklist in items"
              :key="checklist.id"
              :checklist="checklist"
  />

  <tr v-if="!items.length">
    <td :colspan="columnsCount"
        class="text-center text-text-secondary"
    >
      {{ $t('project.checklist.dialogs.SaveChecklistFromTemplateDialog.noChecklistFound') }}
    </td>
  </tr>
</template>

<script>
import { mapActions } from 'vuex'


import LexisNexisChecklistTableItem from '@/project/checklist/dialogs/LexisNexisChecklistTableItem.vue'
import SavedChecklistTableItem from '@/project/checklist/dialogs/SavedChecklistTableItem.vue'
import { GET_SELF_CONTACT_LIST } from '@/store/modules/user/action_types'

export default {
  name: 'SavedChecklistTableBody',
  components: {
    LexisNexisChecklistTableItem,
    SavedChecklistTableItem,
  },
  props: {
    isLexisNexisChecklist: {
      type: Boolean,
      default: false,
    },
    columnsCount: {
      type: Number,
      default: 0,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  created () {
    if (!this.isLexisNexisChecklist) {
      this.GET_SELF_CONTACT_LIST({ fromUserSubscriptionOnly: true })
    }
  },
  methods: {
    ...mapActions('user', [GET_SELF_CONTACT_LIST]),
  },
}
</script>
